import { createRouter, createWebHistory } from "vue-router";
import AppRouter from "@/Routers/AppRouter"

const routes = [
  ...AppRouter
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ top: 0, behavior: "smooth" });
      }, 50);
    });
  },
});

export default router